export default __webpack_public_path__ + "static/media/buddy-lightsaber-purple.0c621a30.png";